import CloseIcon from "@mui/icons-material/Close";
import {
  Backdrop,
  Box,
  Button,
  Dialog,
  Fade,
  Stack,
  Typography,
} from "@mui/material";

export default function DeactivateIngredientModal({
  open,
  ingredient,
  loading = false,
  onClose,
  onConfirm,
}) {
  const ingredientName = ingredient?.name || "este insumo";
  const presentationCount = Number(ingredient?.activePurchaseItemCount || 0);

  return (
    <Dialog
      open={!!open}
      onClose={loading ? undefined : onClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      PaperProps={{
        sx: {
          bgcolor: "transparent",
          boxShadow: "none",
          borderRadius: "30px",
          overflow: "visible",
        },
      }}
      slotProps={{
        backdrop: {
          timeout: 180,
          sx: { bgcolor: "rgba(2, 8, 23, 0.45)", backdropFilter: "blur(3px)" },
        },
      }}
    >
      <Fade in={!!open} timeout={180}>
        <Box
          sx={{
            bgcolor: "neutral.500",
            borderRadius: "32px",
            p: { xs: 2.5, sm: 3.5 },
            boxShadow: "0px 20px 60px rgba(0,0,0,.28)",
            width: "min(92vw, 560px)",
          }}
        >
          <Stack spacing={2.5} sx={{ width: "100%", alignItems: "center" }}>
            <Box
              sx={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                px: "24px",
                py: "11px",
                bgcolor: "secondary.50",
                borderRadius: "33px",
                boxShadow: "inset 0px 0px 3px rgba(142, 142, 159, 0.5)",
              }}
            >
              <Typography
                sx={{
                  fontSize: "19px",
                  fontWeight: 800,
                  color: "primary.900",
                  lineHeight: 1,
                }}
              >
                Quitar de la lista
              </Typography>
            </Box>

            <Box
              sx={{
                width: "100%",
                bgcolor: "rgba(247, 247, 248, 1)",
                borderRadius: "22px",
                boxShadow: "inset 0px 0px 2px rgba(96, 96, 113, 0.5)",
                p: { xs: 2.25, sm: 2.75 },
              }}
            >
              <Typography
                sx={{
                  fontSize: "17px",
                  fontWeight: 700,
                  color: "primary.900",
                  lineHeight: 1.4,
                }}
              >
                ¿Querés quitar “{ingredientName}” de la lista?
              </Typography>

              <Typography
                sx={{
                  mt: 1.4,
                  fontSize: "13px",
                  fontWeight: 600,
                  color: "primary.800",
                  opacity: 0.72,
                }}
              >
                El insumo dejará de mostrarse en esta tabla. Podés volver a agregarlo
                más adelante desde la sección de “Agregar Insumos”.
              </Typography>

              {presentationCount > 0 ? (
                <Typography
                  sx={{
                    mt: 1.4,
                    fontSize: "13px",
                    fontWeight: 800,
                    color: "error.dark",
                  }}
                >
                  Tiene {presentationCount} {presentationCount === 1 ? "presentación asociada" : "presentaciones asociadas"}. No se eliminarán: se conservarán y volverán a estar disponibles si agregás nuevamente el insumo.
                </Typography>
              ) : null}
            </Box>

            <Stack
              direction="row"
              spacing={1.5}
              sx={{
                width: "100%",
                justifyContent: "flex-end",
                flexWrap: "wrap",
              }}
            >
              <Button
                variant="contained"
                onClick={onClose}
                disabled={loading}
                sx={{
                  textTransform: "none",
                  fontSize: "15px",
                  fontWeight: 800,
                  borderRadius: "33px",
                  px: 3,
                  minHeight: 44,
                  bgcolor: "secondary.50",
                  color: "primary.900",
                  boxShadow: "inset 0px 0px 3px rgba(142, 142, 159, 0.5)",
                  "&:hover": {
                    bgcolor: "secondary.100",
                    boxShadow: "inset 0px 0px 4px rgba(117, 117, 138, 0.5)",
                  },
                }}
              >
                Cancelar
              </Button>

              <Button
                variant="contained"
                startIcon={<CloseIcon sx={{ fontSize: 18 }} />}
                onClick={onConfirm}
                disabled={loading}
                sx={{
                  textTransform: "none",
                  fontSize: "15px",
                  fontWeight: 800,
                  borderRadius: "33px",
                  px: 3,
                  minHeight: 44,
                  bgcolor: "secondary.500",
                  color: "logoblanco",
                  boxShadow: "0px 8px 20px rgba(76, 72, 141, 0.24)",
                  "&:hover": {
                    bgcolor: "secondary.600",
                    boxShadow: "0px 10px 24px rgba(76, 72, 141, 0.3)",
                  },
                  "&:disabled": {
                    bgcolor: "secondary.200",
                    color: "rgba(255, 255, 255, 0.7)",
                  },
                }}
              >
                {loading ? "Quitando..." : "Quitar"}
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Fade>
    </Dialog>
  );
}
